import styled from 'particles/themes/styled'
import { theme } from 'theme'

interface DividerProps {
    className?: string
    width?: string
    height?: string
    color?: string
    maxWidth?: string
    my?: string
}

export default styled.div<DividerProps>`
    width: ${({ width }) => (width ? width : '100%')};
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : undefined)};
    height: ${({ height }) => (height ? height : '1px')};
    background-color: ${({ color }) => (color ? color : theme.newColors.neutral200)};
    ${({ my }) => (my ? { marginTop: my, marginBottom: my } : undefined)}
    flex-shrink: 0;
`
